import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { AgendaProgram } from 'sections/Events/components/AgendaProgram';
import { agendaData } from 'sections/Events/FutureOfFreight/data';
import styles from 'sections/Events/FutureOfFreight/components/SectionAgenda/SectionAgenda.module.scss';

const cn = classNames.bind(styles);

const SectionAgenda = (): ReactElement => {
  return (
    <section id="agenda" className={cn('agenda')}>
      <div className={cn('container')}>
        <div className={cn('agenda__content')}>
          <div className={cn('agenda__heading')}>
            <h2 className={cn('agenda__title-h2')}>Agenda</h2>
            <p className={cn('agenda____title-description')}>
              The 1st Digital Freight Alliance conference in Thailand 19 July 2022
            </p>
          </div>
          <AgendaProgram agendaData={agendaData} border={false} title="Tuesday, 19 July 2022" />
        </div>
      </div>
    </section>
  );
};

export default SectionAgenda;